import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-draw.png'

const RectBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default RectBtn
